import { create } from 'zustand'
import type { Moment } from 'moment';
import type { SerialBond } from '../deal-builder/pages/debt-service-page.tsx';

/**
 * Holds the maturity schedule extracted from an uploaded PDF between the
 * moment the user imports the file and the moment the deal is built, where
 * it replaces the default auto-generated bonds. Also keeps the extraction
 * warnings so they can be shown to the user after the import.
 */
interface DealBuilderExtractionStore {
  extractedBonds: SerialBond[],
  termRanges: [Moment, Moment][],
  reviewFields: string[],
  warnings: string[],
  sourceFileName: string | undefined,
  extracting: boolean,

  setExtraction: (
    extractedBonds: SerialBond[],
    termRanges: [Moment, Moment][],
    reviewFields: string[],
    warnings: string[],
    sourceFileName: string,
  ) => void,
  setExtracting: (extracting: boolean) => void,
  dismissWarnings: () => void,
  clearExtraction: () => void,
}

const useDealBuilderExtractionStore = create<DealBuilderExtractionStore>((set) => ({
  extractedBonds: [],
  termRanges: [],
  reviewFields: [],
  warnings: [],
  sourceFileName: undefined,
  extracting: false,

  setExtraction: (extractedBonds, termRanges, reviewFields, warnings, sourceFileName) =>
    set({ extractedBonds, termRanges, reviewFields, warnings, sourceFileName }),
  setExtracting: (extracting: boolean) => set({ extracting }),
  dismissWarnings: () => set({ warnings: [] }),
  clearExtraction: () => set({
    extractedBonds: [],
    termRanges: [],
    reviewFields: [],
    warnings: [],
    sourceFileName: undefined,
  }),
}));

export default useDealBuilderExtractionStore;
